module.exports = __webpack_public_path__ + "static/november-3-ed3f8061d752c51d38f5d896d8d4f130.png";